import {
  notesConstants,
  alertConstants,
  userConstants,
} from "../constants";
import { notesService } from "../services";
import { alertActions } from "./alert.actions.js";

export const notesActions = {
  getNotes
};
function getNotes(org_id, deal_jacket_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching notes..."));
    dispatch(listRequest(org_id, deal_jacket_id));

    notesService.getNotes(org_id, deal_jacket_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

}


  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id, deal_jacket_id) {
    return {
      type: notesConstants.NOTES_REQUEST,
      org_id,
      deal_jacket_id,
    };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
function success(list) {
    return {
      type: notesConstants.NOTES_SUCCESS,
      list,
    };
  }
  function failure(message) {
    return {
      type: notesConstants.NOTES_FAILURE,
      message,
    };
  }
